import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { useDispatch, useSelector } from 'react-redux'
import { setFilterToDate } from '@app/actions/events'
import { dateErrors } from '@app/lib/Events/filters'
import { format } from 'date-fns'
import useStyles from './FilterToDate.style'

const FilterToDate = (): Node => {
  const dispatch = useDispatch()
  const { classes } = useStyles()
  const { filterToDate } = useSelector((state) => state.events)
  const [date, setDate] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!filterToDate) {
      setDate(null)
    }
  }, [filterToDate])

  useEffect(() => {
    if (date) {
      if (date.toString() !== 'Invalid Date' && !dateErrors.includes(error)) {
        dispatch(setFilterToDate(date))
      }
    }
  }, [error])

  const handleValidationError = (err, selectedDate) => {
    setError(err)
    setDate(selectedDate)
  }

  const handleDateChange = (selectedDate) => {
    if (!selectedDate) {
      setDate(null)
      dispatch(setFilterToDate(''))
      return
    }

    const formattedDate = format(selectedDate, 'yyyy-MM-dd')
    setDate(formattedDate)
    dispatch(setFilterToDate(formattedDate))
  }

  return (
    <div className={classes.container}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Typography className={classes.label}>
          {I18n.t('my_events.to')}
        </Typography>
        <DatePicker
          format="dd/MM/yyyy"
          value={date ? new Date(date) : null}
          onChange={handleDateChange}
          onError={(err, val) => handleValidationError(err, val)}
          slotProps={{
            textField: {
              variant: 'standard',
              className: classes.datePicker,
            },
          }}
        />
      </LocalizationProvider>
    </div>
  )
}

export default FilterToDate
